import { MarginOrderDirection } from '@swyftx/margin/build/types';

import {
  CloseScenarioLongMarket,
  CloseScenarioLongMarketMobile,
  CloseScenarioLongStopLoss,
  CloseScenarioLongStopLossMobile,
  CloseScenarioLongTakeProfit,
  CloseScenarioLongTakeProfitMobile,
  CloseScenarioShortMarket,
  CloseScenarioShortMarketMobile,
  CloseScenarioShortStopLoss,
  CloseScenarioShortStopLossMobile,
  CloseScenarioShortTakeProfit,
  CloseScenarioShortTakeProfitMobile,
} from './illustrations';

export const SIZE_LOTS = '3.0';
export const SYMBOL = 'ETHUSD';

export const DATA_FIELDS = {
  [MarginOrderDirection.Long]: {
    market: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: '1114.00',
      averageFillPriceCloseBelow: '850.00',
      takeProfitPrice: null,
      stopLossPrice: null,
      closingProfit: '~$533.10 AUD',
      closingLoss: '~$701.50 AUD',
      illustration: (
        <>
          <CloseScenarioLongMarket className='hidden sm:block' />
          <CloseScenarioLongMarketMobile className='block sm:hidden' />
        </>
      ),
    },
    takeProfit: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: '1,200.00',
      averageFillPriceCloseBelow: null,
      takeProfitPrice: '1,200.00',
      stopLossPrice: null,
      closingProfit: '~$935.50 AUD',
      closingLoss: null,
      illustration: (
        <>
          <CloseScenarioLongTakeProfit className='hidden sm:block' />
          <CloseScenarioLongTakeProfitMobile className='block sm:hidden' />
        </>
      ),
    },
    stopLoss: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: null,
      averageFillPriceCloseBelow: '800.00',
      takeProfitPrice: null,
      stopLossPrice: '800.00',
      closingProfit: null,
      closingLoss: '~$935.50 AUD',
      illustration: (
        <>
          <CloseScenarioLongStopLoss className='hidden sm:block' />
          <CloseScenarioLongStopLossMobile className='block sm:hidden' />
        </>
      ),
    },
  },
  [MarginOrderDirection.Short]: {
    market: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: '1114.00',
      averageFillPriceCloseBelow: '850.00',
      takeProfitPrice: null,
      stopLossPrice: null,
      closingProfit: '~$701.50 AUD',
      closingLoss: '~$533.10 AUD',
      illustration: (
        <>
          <CloseScenarioShortMarket className='hidden sm:block' />
          <CloseScenarioShortMarketMobile className='block sm:hidden' />
        </>
      ),
    },
    takeProfit: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: null,
      averageFillPriceCloseBelow: '800.00',
      takeProfitPrice: '800.00',
      stopLossPrice: null,
      closingProfit: '~$935.50 AUD',
      closingLoss: null,
      illustration: (
        <>
          <CloseScenarioShortTakeProfit className='hidden sm:block' />
          <CloseScenarioShortTakeProfitMobile className='block sm:hidden' />
        </>
      ),
    },
    stopLoss: {
      averageFillPrice: '1,000.00',
      averageFillPriceCloseAbove: '1,200.00',
      averageFillPriceCloseBelow: null,
      takeProfitPrice: null,
      stopLossPrice: '1,200.00',
      closingProfit: null,
      closingLoss: '~$935.50 AUD',
      illustration: (
        <>
          <CloseScenarioShortStopLoss className='hidden sm:block' />
          <CloseScenarioShortStopLossMobile className='block sm:hidden' />
        </>
      ),
    },
  },
};
